// Source unique de l'ordre des statuts de trajet et du découpage en phases.
//
// Un trajet couvre deux métiers: l'IMPORTATION (aller, douane de sortie,
// chargement, retour, jusqu'à l'entrée validée) puis la LIVRAISON sur le
// territoire. Le pivot est CLEARED_CUSTOMS_ENTRY, dernière étape du corridor.
//
// Ce fichier reflète backend/app/core/workflow_defaults.py. Toute autre liste
// de statuts dans le front doit réimporter d'ici plutôt que se recopier.

import { libelle, tableAvecRepli } from './libelles';

export const TRIP_PHASE_IMPORT = 'IMPORTATION';
export const TRIP_PHASE_DELIVERY = 'LIVRAISON';
export const TRIP_PHASE_CLOSED = 'CLOTURE';

export const TRIP_STATUS_ORDER = [
  'CREATED',
  'EN_ROUTE_TO_BORDER',
  'AT_CUSTOMS_EXIT',
  'CLEARED_CUSTOMS_EXIT',
  'EN_ROUTE_TO_LOADING',
  'LOADING',
  'EN_ROUTE_TO_ENTRY_CUSTOMS',
  'AT_CUSTOMS_ENTRY',
  'CLEARED_CUSTOMS_ENTRY',
  'ARRIVED_AT_DEPOT',
  'EN_ROUTE_TO_DELIVERY',
  'DELIVERED',
  'COMPLETED',
];

export const PHASE_PIVOT_STATUS = 'CLEARED_CUSTOMS_ENTRY';

const PIVOT_INDEX = TRIP_STATUS_ORDER.indexOf(PHASE_PIVOT_STATUS);

export const IMPORT_PHASE_STATUSES = TRIP_STATUS_ORDER.slice(0, PIVOT_INDEX + 1);
export const DELIVERY_PHASE_STATUSES = TRIP_STATUS_ORDER.slice(PIVOT_INDEX + 1);

// Transitions autorisées, miroir de DEFAULT_TRIP_TRANSITIONS côté serveur.
// Le dépôt est facultatif: après l'entrée validée, on part au dépôt OU
// directement en livraison.
export const TRIP_TRANSITIONS = {
  CREATED: ['EN_ROUTE_TO_BORDER'],
  EN_ROUTE_TO_BORDER: ['AT_CUSTOMS_EXIT'],
  AT_CUSTOMS_EXIT: ['CLEARED_CUSTOMS_EXIT'],
  CLEARED_CUSTOMS_EXIT: ['EN_ROUTE_TO_LOADING'],
  EN_ROUTE_TO_LOADING: ['LOADING'],
  LOADING: ['EN_ROUTE_TO_ENTRY_CUSTOMS'],
  EN_ROUTE_TO_ENTRY_CUSTOMS: ['AT_CUSTOMS_ENTRY'],
  AT_CUSTOMS_ENTRY: ['CLEARED_CUSTOMS_ENTRY'],
  CLEARED_CUSTOMS_ENTRY: ['ARRIVED_AT_DEPOT', 'EN_ROUTE_TO_DELIVERY'],
  ARRIVED_AT_DEPOT: ['EN_ROUTE_TO_DELIVERY'],
  EN_ROUTE_TO_DELIVERY: ['DELIVERED'],
  DELIVERED: ['COMPLETED'],
  COMPLETED: [],
  CANCELLED: [],
};

// Alias de `LIBELLES.tripPhase` (lib/libelles.js).
export const PHASE_LABELS = tableAvecRepli('tripPhase', [
  TRIP_PHASE_IMPORT,
  TRIP_PHASE_DELIVERY,
  TRIP_PHASE_CLOSED,
]);

export function getTripPhase(status) {
  const normalized = status === 'RETURNING' ? 'COMPLETED' : status;
  if (DELIVERY_PHASE_STATUSES.includes(normalized)) return TRIP_PHASE_DELIVERY;
  if (IMPORT_PHASE_STATUSES.includes(normalized)) return TRIP_PHASE_IMPORT;
  return TRIP_PHASE_CLOSED;
}

export function phaseLabel(phase) {
  return libelle('tripPhase', phase);
}

export function phaseStatuses(phase) {
  if (phase === TRIP_PHASE_IMPORT) return IMPORT_PHASE_STATUSES;
  if (phase === TRIP_PHASE_DELIVERY) return DELIVERY_PHASE_STATUSES;
  return [];
}

// Progression DANS la phase courante: un trajet qui démarre sa livraison est au
// début de ce qui reste à faire, pas à 75% comme le dirait une barre unique
// couvrant les 13 étapes.
// Sans dépôt (`managesDepot: false`), l'étape dépôt ne compte pas.
export function getPhaseProgress(status, { managesDepot = true } = {}) {
  const normalized = status === 'RETURNING' ? 'COMPLETED' : status;
  if (normalized === 'CANCELLED') return 0;
  const phase = getTripPhase(normalized);
  const statuses = phaseStatuses(phase).filter(
    (step) => managesDepot || step !== 'ARRIVED_AT_DEPOT',
  );
  const index = statuses.indexOf(normalized);
  if (index === -1 || statuses.length < 2) return index === -1 ? 0 : 100;
  return Math.round((index / (statuses.length - 1)) * 100);
}
